export const data = {
    name: '友阿股份',
    code: '002277',
    score: '4.8',
    bitThan: '27%',
    suggest: "买入",
    qushi: [
        {
            id: 1,
            name: '短期趋势',
            txt: '弱势下跌过程中,可逢高卖出,暂不考虑买进.'
        },
        {
            id: 2,
            name: '中期趋势',
            txt: "下跌有所减缓,仍应保持谨慎"
        },
        {
            id: 3,
            name: '长期趋势',
            txt: '迄今为止,共3家主力机构,持仓量总计约5.1亿股,占流通A股的36.55%'
        },
    ],
    summary: '近期的平均成本为4.55元,股价在成本上方运行.空头行情中,目前的反弹趋势有所减缓,投资者可适当关注.该股资金方面呈现流出状态,投资者请谨慎投资.该公司运营状况尚可,暂时未获得多数机构的显著认同,后续可继续关注',
    zhengu: [
        {
            id: 1,
            score: '6',
            type: "技术面诊股",
            content: "近期的平均成本未4.55元,股价在成本上方运行.空头行情中,目前反弹趋势有所减缓,投资者可适当关注"
        }, {
            id: 2,
            score: '1.6',
            type: "资金面诊股",
            content: "近5日内该股资金流出较多.据统计,近10日内主力没有控盘.近5日该股资金总体呈流出状态."
        }, {
            id: 3,
            score: '4.0',
            type: "消息面诊股",
            content: "近期该股利空消息较多,投资时需谨慎"
        }, {
            id: 4,
            score: '5.3',
            type: "行业面诊股",
            content: "近10日来该行业走势不明显,明显跑输大盘.最近120个交易日,机构评级以增持为主,认为该行业有一定的投资价值"
        }, {
            id: 5,
            score: '5.5',
            type: "基本面诊股",
            content: "该公司经营状况尚可,暂时未获得多数机构的显著认可"
        },
    ],
    riskTip: '风险提示: 该诊断结果通过运算模型加工客观数据而成, 仅供参考不构成投资建议.'

}